import { useState, useEffect } from 'react';
import classnames from 'classnames';
import downtrangle from './image/downtrangle.svg';
import { Popover, PopoverTrigger, PopoverContent } from '@leadsnavi/ui-kit';
import * as EditorTypeAll from '../tinymce.d';
interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const defaultFontSizes = [
  { name: '10', value: '10px' },
  { name: '11', value: '11px' },
  { name: '12', value: '12px' },
  { name: '13', value: '13px' },
  { name: '14', value: '14px' },
  { name: '16', value: '16px' },
  { name: '18', value: '18px' },
  { name: '20', value: '20px' },
  { name: '22', value: '22px' },
  { name: '24', value: '24px' },
  { name: '28', value: '28px' },
  { name: '32', value: '32px' },
  { name: '36', value: '36px' },
  { name: '48', value: '48px' },
];
const mapPTtoPX = {
  '6pt': '8px',
  '7pt': '9px',
  '7.5pt': '10px',
  '8pt': '11px',
  '9pt': '12px',
  '10pt': '13px',
  '10.5pt': '14px',
  '11pt': '15px',
  '12pt': '16px',
  '13pt': '17px',
  '13.5pt': '18px',
  '14pt': '19px',
  '14.5pt': '20px',
  '15pt': '21px',
  '16pt': '22px',
  '17pt': '23px',
  '18pt': '24px',
  '20pt': '26px',
  '22pt': '29px',
  '24pt': '32px',
  '26pt': '35px',
  '27pt': '36px',
  '28pt': '37px',
  '29pt': '38px',
  '30pt': '40px',
  '32pt': '42px',
  '34pt': '45px',
  '36pt': '48px',
};
const Fontsizeselect = ({ editorInstance }: Props) => {
  const [visible, setVisible] = useState(false);
  const [selectFontSize, setSelectFontSize] = useState('16');

  useEffect(() => {
    if (editorInstance) {
      editorInstance.on('NodeChange', (event: { element: Element }) => {
        let fontSize = editorInstance.dom.getStyle(event.element, 'fontSize', true);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (fontSize && fontSize.indexOf('pt') > -1 && (mapPTtoPX as any)[fontSize]) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          fontSize = (mapPTtoPX as any)[fontSize];
        }
        // console.log('fontSize', setSelectFontSize);
        setSelectFontSize(`${parseInt(fontSize)}`);
      });
    }
  }, [editorInstance]);

  const selectFontSizeCl = (fontSize: { name: string; value: string }) => {
    const value = fontSize.value;
    if (!editorInstance) return;
    setSelectFontSize(`${parseInt(value)}`);
    editorInstance.execCommand('FontSize', false, value);
    setVisible(false);
  };

  return (
    <Popover open={visible} onOpenChange={setVisible} modal={true}>
      <PopoverTrigger asChild>
        <div
          className={classnames([
            'inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]',
            // selectFontSize && selectFontSize !== '16' && "bg-[#E5E5E5] hover:bg-[#E5E5E5]"
          ])}
        >
          <div className="flex items-center justify-between w-6 h-4.5 gap-0.5 font-normal text-sm">
            <span>{selectFontSize}</span>
            <img src={downtrangle} className="mt-1" />
          </div>
        </div>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto p-0 bg-white border border-gray-300 rounded-sm shadow-lg animate-in fade-in-0 zoom-in-95 duration-200"
        side="top"
        align="start"
        sideOffset={5}
        style={{ zIndex: 9999 }}
      >
        <div className="text-xs">
          <div className="p-0.5 max-h-[200px] overflow-auto">
            {defaultFontSizes.map((font) => (
              <div
                key={font.name}
                className={classnames([
                  'flex items-center h-7 w-7 rounded justify-center cursor-pointer hover:bg-[#E5E5E5]',
                ])}
                onClick={() => {
                  selectFontSizeCl(font);
                }}
              >
                {font.name}
              </div>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default Fontsizeselect;
